import { HttpClient } from '@angular/common/http';
import { Directive, OnInit } from '@angular/core';
import { TranslationStore } from './translation';
import { TranslationService } from './translation.service';
import { Observable } from 'rxjs/internal/Observable';

@Directive()
export abstract class TranslatableComponent  implements OnInit {
    constructor(protected _translationService: TranslationService, protected _httpClient: HttpClient) {}

    ngOnInit(): void {
        this._translationService.languageList.forEach((language) => {
            try {
                this.readTranslations(this._httpClient, language).subscribe((translations) => {
                    this._translationService.addTranslations(translations, language);
                    this.onInit();
                });
            } catch (err) {
                
            }
        });
    }

    abstract readTranslations(http: HttpClient, language: string): Observable<TranslationStore>;
    abstract onInit(): void;
}
